
TS.ns('WL');

WL.leasingApplicationCollateralModel = new Class({
    Extends: WL.leasingApplicationBaseModel,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;
        
        me.parent(config);
        var warrantyList = me.getDomainProperty('dgDocumentWarrantyCollection_Property');
        if (warrantyList) {
            warrantyList.getFieldByName('gcGuarantor_Field').on('propertyChanged', me.onGuarantorChanged, me);
            var warrantyItemField = warrantyList.getFieldByName('gcWarrantyItemName_Field');
            if (warrantyItemField) {
                warrantyItemField.on('propertyChanged', me.onWarrantyItemChanged, me);
            }
        }
    },
    onGuarantorChanged: function (selectedRecord) {
        var me = this,
            warrantyList = me.getDomainProperty('dgDocumentWarrantyCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            warrantyList.SelectedItem().PartnerCode(selectedRecord.sender.SelectedItem().PartnerCode);
        }
    },
    onWarrantyItemChanged: function (selectedRecord) {
        var me = this,
            warrantyList = me.getDomainProperty('dgDocumentWarrantyCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            warrantyList.SelectedItem().ItemCode(selectedRecord.sender.SelectedItem().ItemCode);
        }
    }

});

